import algoliasearch from 'algoliasearch/lite';
import 'instantsearch.css/themes/algolia-min.css';

export default {
  data: () => ({
    searchClient: algoliasearch(
      process.env.VUE_APP_ALGOLIA_APP_ID,
      process.env.VUE_APP_ALGOLIA_API,
    ),

    emptyArray: false,
  }),

  methods: {
    indicesToSuggestions(indices) {
      const items = indices.map(({ hits }) => ({ data: hits }));
      if (!this.emptyArray && items[0].data.length === 0) {
        this.emptyArray = true;
      }
      if (this.emptyArray && items[0].data.length > 0) {
        this.emptyArray = false;
      }
      return items;
    },
    getSuggestionValue() {
      return '';
      // return suggestion.item[`description_${this.$i18n.locale}`];
    },
  },
};
